import React from 'react';
import {Nav} from './Nav/Nav';
import {Footer} from '../Footer/Footer';
import {Professionnels} from './Professionnels/Professionnels';
import {Forms} from './Form/Form';
import {Nospartenaires} from './Nospartenaires/Nospartenaires';


class Pros extends React.Component {
  render() {
    return (
  <div>
   <Nav/>
   <Professionnels/>
   <Forms/>
   <Nospartenaires/>
   <Footer/>
  </div>
    );
  }
}

Pros.defaultProps = {
};

export default Pros;


// WEBPACK FOOTER //
// ./src/components/Professionnel/Pros.js